export default class StorageService {

  static setSessionData(key, value) {
    if (typeof value === 'object')
      sessionStorage.setItem(key, JSON.stringify(value));
    else
      sessionStorage.setItem(key, `${value}`);
  }

  static getSessionData(key) {
    let value = '';
    try {
      value = JSON.parse(sessionStorage.getItem(key));
    } catch (e) {
      value = `${sessionStorage.getItem(key)}`;
    }
    return value;
  }
}



// WEBPACK FOOTER //
// ./src/services/storageApi.js